 /* globals urls, RSVP, KoisLoader */

// New class for Kois Cart loader functionality
window.KoisCart = function(){
	KoisLoader.call( this );
	
	// Override properties as necessary
	this.validSections = ['koistomerCredits'];
	this.requestData = {
		action: 'fetch_kois_cart_sections'
	};
	this.sectionMappings = {
		koistomerCredits: {id: 'cart-koistomer-credits-contain'}
	};
};

// Inherit from KoisLoader class
KoisCart.prototype = Object.create( KoisLoader.prototype );
KoisCart.prototype.constructor = KoisCart;

// Override section event handler initialization function
KoisCart.prototype.initSectionEventHandlers = function(sectionContain, sectionName){
	// Re-initialize Koistomer Credits click handlers after DOM is updated
	jQuery( document ).trigger( 'koistomer_credits_dom_updated' );
	// Refresh cart totals to ensure proper applied amount is displayed after pulling updated Kistomer Credits amountd from method
	jQuery( document ).trigger( 'wc_update_cart' );
};